/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CheckStateRequest,
  NetSuiteShipmentStatusReport,
  ResyncRequest,
  ResyncResponse,
} from "../models/index";
import {
  CheckStateRequestFromJSON,
  CheckStateRequestToJSON,
  NetSuiteShipmentStatusReportFromJSON,
  NetSuiteShipmentStatusReportToJSON,
  ResyncRequestFromJSON,
  ResyncRequestToJSON,
  ResyncResponseFromJSON,
  ResyncResponseToJSON,
} from "../models/index";

export interface CheckStateOperationRequest {
  checkStateRequest: CheckStateRequest;
}

export interface ResyncOperationRequest {
  resyncRequest: ResyncRequest;
}

/**
 *
 */
export class NetSuiteSyncApi extends runtime.BaseAPI {
  /**
   */
  async checkStateRaw(
    requestParameters: CheckStateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<NetSuiteShipmentStatusReport>> {
    if (requestParameters["checkStateRequest"] == null) {
      throw new runtime.RequiredError(
        "checkStateRequest",
        'Required parameter "checkStateRequest" was null or undefined when calling checkState().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/netsuite-sync/check-state`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CheckStateRequestToJSON(requestParameters["checkStateRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetSuiteShipmentStatusReportFromJSON(jsonValue),
    );
  }

  /**
   */
  async checkState(
    requestParameters: CheckStateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<NetSuiteShipmentStatusReport> {
    const response = await this.checkStateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async resyncRaw(
    requestParameters: ResyncOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResyncResponse>> {
    if (requestParameters["resyncRequest"] == null) {
      throw new runtime.RequiredError(
        "resyncRequest",
        'Required parameter "resyncRequest" was null or undefined when calling resync().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/netsuite-sync/resync`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ResyncRequestToJSON(requestParameters["resyncRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResyncResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async resync(
    requestParameters: ResyncOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResyncResponse> {
    const response = await this.resyncRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
